import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from '../Modal/Modal';
import Button from '../../_atomic/Button/Button';
import EmailField from '../EmailField/EmailField';
import CreateAdminModalContext from './CreateAdminModalContext';
import { CONTEXT_PROVIDERS, ERROR, TEXT_FIELD_STATUS, LOADING, SUCCESS } from '../../../utils/constants';
import PasswordField from '../PasswordField/PasswordField';
import { getFieldCreateAdminState } from '../../../utils/helpers';
import './CreateAdminModal.scss';
import ConnectedTextField from '../../_atomic/ConnectedTextField/ConnectedTextField';
import FullNameField from '../FullNameField/FullNameField';
import TimeZonePicker from '../TimeZonePicker/TimeZonePicker';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';
import ErrorModal from '../ErrorModal/ErrorModal';
/* eslint import/newline-after-import: "off" */

const emailFieldName = 'email';
const passwordFieldName = 'password';
const timeZoneFieldName = 'timezone';
const fullNameFieldName = 'fullName';
const positionFieldName = 'position';

class CreateAdminModal extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    disableModal: PropTypes.func.isRequired,
    specifiedValidator: PropTypes.shape({ email: PropTypes.bool, password: PropTypes.bool }),
    status: PropTypes.string.isRequired,
    annulAdminError: PropTypes.func.isRequired,
    createAdminUser: PropTypes.func.isRequired,
    error: PropTypes.string.isRequired,
    // getAllUsersFull: PropTypes.func.isRequired,
    getAllAdminsFull: PropTypes.func.isRequired,
  };
  static defaultProps = {
    specifiedValidator: {
      email: false,
      password: false,
    },
  }
  constructor() {
    super();
    this.fields = {};
  }
  state = {};
  componentWillMount() {
    this.setState({
      formStatus: TEXT_FIELD_STATUS.INITIAL,
      fieldStep: 0,
      fields: {
        [emailFieldName]: getFieldCreateAdminState(),
        [passwordFieldName]: getFieldCreateAdminState(),
        [fullNameFieldName]: getFieldCreateAdminState(),
        [timeZoneFieldName]: getFieldCreateAdminState(),
        [positionFieldName]: getFieldCreateAdminState(),
      },
    });
  }
  componentDidUpdate() {
    const {
      status,
      getAllAdminsFull,
      annulAdminError,
    } = this.props;
    const createStatusAdmin = status === SUCCESS;
    if (createStatusAdmin) {
      annulAdminError();
      getAllAdminsFull();
      this.setState({ fieldStep: 0 });
      this.disableCreateModal();
    }
  }
  componentWillUnmount() {
    this.setState({ fields: {} });
  }
  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID) { validFields += 1; }
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID) { invalidFields += 1; }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }
    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };
  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
    const fields = { ...this.state.fields };
    fields[passwordFieldName].hint = 'Should be at least 6 symbols, contain uppercase, lowercase and one number';
    this.setState(() => ({ fields }));
  };
  fieldChangeHandler = ({ name, value }) => {
    const fields = { ...this.state.fields };
    let formStatus = { ...this.state.formStatus };
    fields[name].value = value;
    if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    this.setState(() => ({ fields, formStatus }));
  };
  fieldFocusHandler = ({ name, isFocused }) => {
    const fields = { ...this.state.fields };
    let { formStatus } = this.state;
    fields[name].isFocused = isFocused;
    if (!isFocused) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    this.setState(() => ({ fields, formStatus }));
  };
  disableCreateModal = () => {
    const { disableModal } = this.props;
    const { fields } = this.state;
    fields[passwordFieldName].value = '';
    fields[positionFieldName].value = '';
    fields[timeZoneFieldName].value = '';
    fields[fullNameFieldName].value = '';
    fields[emailFieldName].value = '';
    this.setState(() => ({ fields }));
    return disableModal(false);
  }
  submitHandler = () => {
    const { createAdminUser } = this.props;
    const fields = { ...this.state.fields };
    Object.keys(this.fields).forEach((name) => {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
    });
    const formStatus = this.getFormStatus(fields);
    this.setState(
      () => ({
        fields,
        formStatus,
      }),
      () => {
        if (formStatus === TEXT_FIELD_STATUS.VALID) {
          const data = {};
          Object.keys(fields).forEach((fieldName) => {
            data[fieldName] = fields[fieldName].value;
          });
          createAdminUser(data);
        }
      },
    );
  };
  nextHopeButton = (status) => {
    const { fieldStep } = this.state;
    if (!status) {
      if (fieldStep === 1) {
        this.submitHandler();
      } else if (fieldStep === 0) {
        this.setState({ fieldStep: 1 });
      }
    }
  }
  render() {
    const {
      visible,
      specifiedValidator,
      status,
      annulAdminError,
      error,
    } = this.props;
    const { formStatus, fields, fieldStep } = this.state;
    const emailField = fields[emailFieldName];
    const passwordField = fields[passwordFieldName];
    const positionField = fields[positionFieldName];
    const timeZoneField = fields[timeZoneFieldName];
    const fullNameField = fields[fullNameFieldName];
    const disabledButton = formStatus === TEXT_FIELD_STATUS.INVALID;
    const isLoading = status === LOADING;
    const isError = status === ERROR;
    const authFormClasses = classNames({
      'create-admin-form': true,
    });
    return (
      <Modal
        visible={visible}
        requestClose={this.requestClose}
        className="upload-media-modal"
      >
        <div className="delete-user-modal">
          <div className="sections-wrapper">
            <div className="select-wrapper">
              <div className="main-label-no-transform">
                <span style={{ marginRight: '15px' }}>Create administrator</span>
              </div>
              {fieldStep === 0 &&
              <div className={authFormClasses}>
                <ErrorModal requestClose={annulAdminError} visible={isError} error={error} />
                <CreateAdminModalContext.Provider
                  value={{
                    register: this.registerField,
                    changeHandler: this.fieldChangeHandler,
                    focusHandler: this.fieldFocusHandler,
                  }}
                >
                  <EmailField
                    name={emailFieldName}
                    value={emailField.value}
                    status={emailField.status}
                    isFocused={emailField.isFocused}
                    errorText={emailField.errorText}
                    hint={emailField.hint}
                    isRequired
                    needSpecifiedValidator={specifiedValidator.email}
                    contextProvider={CONTEXT_PROVIDERS.CreateAdminModalContext}
                  />
                  <PasswordField
                    name={passwordFieldName}
                    value={passwordField.value}
                    status={passwordField.status}
                    isFocused={passwordField.isFocused}
                    errorText={passwordField.errorText}
                    hint={passwordField.hint}
                    contextProvider={CONTEXT_PROVIDERS.CreateAdminModalContext}
                    needSpecifiedValidator={specifiedValidator.password}
                    isRequired
                  />
                </CreateAdminModalContext.Provider>
              </div>
              }
              { fieldStep === 1 &&
              <div className={authFormClasses}>
                <LoadingOverlay visible={isLoading} />
                <ErrorModal requestClose={annulAdminError} visible={isError} error={error} />
                <CreateAdminModalContext.Provider
                  value={{
                    register: this.registerField,
                    changeHandler: this.fieldChangeHandler,
                    focusHandler: this.fieldFocusHandler,
                  }}
                >
                  <FullNameField
                    value={fullNameField.value}
                    status={fullNameField.status}
                    isFocused={fullNameField.isFocused}
                    errorText={fullNameField.errorText}
                    hint={fullNameField.hint}
                    isRequired
                    name={fullNameFieldName}
                    contextProvider={CONTEXT_PROVIDERS.CreateAdminModalContext}
                  />
                  <ConnectedTextField
                    value={positionField.value}
                    status={positionField.status}
                    isFocused={positionField.isFocused}
                    errorText={positionField.errorText}
                    hint={positionField.hint}
                    isRequired
                    errorSign
                    label="Position"
                    placeholder="Position"
                    name={positionFieldName}
                    contextProvider={CONTEXT_PROVIDERS.CreateAdminModalContext}
                  />
                  <TimeZonePicker
                    isRequired
                    registerField={this.registerField}
                    status={timeZoneField.status}
                    value={timeZoneField.value}
                    name={timeZoneFieldName}
                    errorText={timeZoneField.errorText}
                    inputProps={{
                      placeholder: 'Timezone',
                    }}
                    onChange={this.fieldChangeHandler}
                  />
                </CreateAdminModalContext.Provider>
              </div>
              }
              <div className="button-wrapper" style={{ paddingBottom: '25px', marginTop: '25px' }}>
                <Button
                  type="submit"
                  label={fieldStep === 1 ? 'Create' : 'Next'}
                  disabled={disabledButton}
                  clickHandler={() => this.nextHopeButton(disabledButton)}
                />
                <Button
                  type="submit"
                  label={fieldStep === 0 ? 'Close' : 'Back'}
                  clickHandler={
                    fieldStep === 0 ?
                      () => this.disableCreateModal() : () => this.setState({ fieldStep: 0 })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default CreateAdminModal;



// WEBPACK FOOTER //
// ./src/components/_molecules/CreateAdminModal/CreateAdminModal.js